// extracted by css-extract-rspack-plugin
export default {"GoodFitWizardForm":"sputnik__GoodFitWizardForm__QXZ_I","goodFitWizardForm":"sputnik__GoodFitWizardForm__QXZ_I"};